import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor, Alignment, Essentials, Paragraph, Heading, Bold, Italic, Link,
  List, BlockQuote, Table, TableToolbar, MediaEmbed, GeneralHtmlSupport
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';

export function WysiwygEditor({ value, onChange, placeholder = "Start typing..." }) {
  return (
    <div className="border border-gray-200 rounded-2xl overflow-hidden focus-within:border-brand-primary focus-within:ring-2 focus-within:ring-brand-primary/20 transition-all wysiwyg-editor-container">
      <CKEditor
        editor={ClassicEditor}
        data={value || ""}
        config={{
          licenseKey: 'GPL',
          placeholder: placeholder,
          plugins: [
            Essentials, Paragraph, Heading, Bold, Italic, Link,
            List, BlockQuote, Table, TableToolbar, MediaEmbed, Alignment, GeneralHtmlSupport
          ],
          toolbar: [
            "heading", "|",
            "bold", "italic", "link", "alignment", "|",
            "bulletedList", "numberedList", "blockQuote", "|",
            "insertTable", "mediaEmbed", "undo", "redo"
          ],
          alignment: {
            options: [ 'left', 'center', 'right', 'justify' ]
          },
          htmlSupport: {
            allow: [
              {
                name: /.*/,
                attributes: true,
                classes: true,
                styles: true
              }
            ]
          }
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
    </div>
  );
}

export default WysiwygEditor;
